invHdApp.controller('ChangelogController', ['$scope', '$http', '$rootScope', '$location', 
function($scope, $http, $rootScope, $location) {
    
    console.log('ChangelogController initialized');
    $rootScope.changes = [];
    $rootScope.currentDate = new Date();
    
    $scope.newChangelog = {
        changelog_id: '',
        category: '',
        description: ''
    };
    
    $rootScope.showChangelog = function() {
        console.log('showChangelog called');
        if ($location.path().indexOf('customer-orders') > -1) {
            return;
        }
        
        $http.get('/api/changelog/all')
            .then(function(response) {
                console.log('Changelog API response:', response);
                if (response.data && response.data.data && response.data.data.length > 0) {
                    console.log('Changelog data found:', response.data.data);
                    var groupedChanges = {};
                    response.data.data.forEach(function(change) {
                        if (!groupedChanges[change.category]) {
                            groupedChanges[change.category] = {
                                category: change.category,
                                items: []
                            };
                        }
                        groupedChanges[change.category].items.push({
                            id: change.changelog_id,
                            description: change.description,
                            created_at: change.created_at
                        });
                    });
                    
                    $rootScope.changes = Object.values(groupedChanges);
                    $rootScope.currentDate = new Date();
                    console.log('Trying to show modal');
                    $('#changelogModal').modal('show');
                    console.log('Modal show called');
                }
                else {
                    console.log('No changelog data to show');
                }
            })
            .catch(function(error) {
                console.error('Error fetching changelog:', error);
            });
    };

    $scope.saveChangelog = function(changelogs) {
        var data = {
            changelogs: changelogs
        };
        
        $http.post('/api/changelog/save', data)
            .then(function(response) {
                if (response.data && response.data.success) {
                    // Clear the form
                    $scope.changelogs = [{
                        category: '',
                        changelog_id: '',
                        description: ''
                    }];
                    // Refresh changelog list
                    $rootScope.showChangelog();
                }
            })
            .catch(function(error) {
                console.error('Error saving changelog:', error);
            });
    };

    $rootScope.showChangelog();

    $scope.$on('$destroy', function() {
        var modal = $('#changelogModal');
        modal.on('hidden.bs.modal', function() {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        });
        modal.modal('hide');
    });

    $scope.changelogs = [{
        category: '',
        changelog_id: '',
        description: ''
    }];

    $scope.addNewRow = function() {
        $scope.changelogs.push({
            category: '',
            changelog_id: '',
            description: ''
        });
    };

    $scope.removeRow = function(index) {
        if ($scope.changelogs.length > 1) {
            $scope.changelogs.splice(index, 1);
        }
    };

    $scope.isCustomerOrdersPage = function() {
        return window.location.href.indexOf('customer-orders') > -1;
    };

}]); 